import { isMobile } from "contants/common";
import { RouteObject } from "react-router-dom";

import { desktopRoutes } from "./desktopRoutes";
import { mobileRoutes } from "./mobileRoutes";

const routesConfig: RouteObject[] = isMobile ? mobileRoutes : desktopRoutes;

export default routesConfig;
